import React from "react";
import { GoogleMap, useJsApiLoader, MarkerF } from "@react-google-maps/api";

const KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;

const containerStyle = { width: "100%", height: "192px" };

const mapOptions = {
  disableDefaultUI: true,
  zoomControl: true,
  clickableIcons: false,
  gestureHandling: "cooperative",
  styles: [
    { featureType: "poi.business", stylers: [{ visibility: "off" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
  ],
};

export default function GymMap({ lat, lng, name }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: KEY || "",
  });

  if (!KEY) {
    return (
      <div className="w-full h-48 bg-neutral-100 grid place-items-center text-xs text-neutral-500">
        Google Maps key not configured
      </div>
    );
  }
  if (loadError) {
    return (
      <div className="w-full h-48 bg-neutral-100 grid place-items-center text-xs text-red-600">
        Map failed to load
      </div>
    );
  }
  if (!isLoaded) {
    return <div className="w-full h-48 bg-neutral-100 animate-pulse" />;
  }
  const center = { lat: Number(lat) || 53.35, lng: Number(lng) || -6.26 };
  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={14}
      options={mapOptions}
    >
      <MarkerF position={center} title={name} />
    </GoogleMap>
  );
}
